import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { SiteVisitsPage } from '@/features/design/site-visits-page';

const searchSchema = z.object({ visit: z.string().optional().catch(undefined) });

export const Route = createFileRoute('/_app/projects/$projectId/design/site-visits')({
  validateSearch: searchSchema,
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  const search = Route.useSearch();
  return <SiteVisitsPage projectId={projectId} visitId={search.visit} />;
}
